// my rest client
import axios from 'axios';
import config from 'shared/config';

const instance = axios.create({
  baseURL: config.restEndpoint
});

export default instance;
